import { addDays, addMonths, startOfMonth } from "date-fns"

// Generic Constants
export const ITEMS_PER_PAGE = 10
export const DRAWER_ITEMS_PER_PAGE = 20
export const NO_CARDS_PER_PAGE = 10

export const roles = {
  "Portal-Non-CMS-User": "Portal-Non-CMS-User",
  "Portal-User": "Portal-User",
  "Portal-Non-CMS-User-ITIL": "Portal-Non-CMS-User-ITIL",
  "Portal-Client-User": "Portal-Client-User",
  "Portal-Admin": "Portal-Admin"
}

export const isCmsUser = (role) =>
  role === roles["Portal-User"] || role === roles["Portal-Admin"]
export const isAdmin = (role) => role === roles["Portal-Admin"]
export const isExternalUser = (role) =>
  role === roles["Portal-Client-User"] ||
  role === roles["Portal-Non-CMS-User-ITIL"]
export const isInternalUser = (role) => role !== "Portal-Client-User"

export const isClient = (role) => role === roles["Portal-Client-User"]

export const gcpAccountIdRegex =
  /^us-con-gcp-[a-zA-Z][a-zA-Z][a-zA-Z]-\d{7}-\d{6}$/

// ITSM Constants
export const itsmType = {
  INC: "Incidents",
  CHG: "Change Requests",
  SEV: "Service Requests"
}

export const dateFilters = [
  {
    key: 3,
    label: "3 Days",
    startDate: (todaysDate) => addDays(todaysDate, -3),
    endDate: (todaysDate) => todaysDate
  },
  {
    key: 7,
    label: "7 Days",
    startDate: (todaysDate) => addDays(todaysDate, -7),
    endDate: (todaysDate) => todaysDate
  },
  {
    key: 30,
    label: "Month",
    startDate: (todaysDate) => startOfMonth(addMonths(todaysDate, -1)),
    endDate: (todaysDate) => todaysDate
  },
  {
    key: 90,
    label: "3 Months",
    startDate: (todaysDate) => startOfMonth(addMonths(todaysDate, -3)),
    endDate: (todaysDate) => todaysDate
  },
  {
    key: 180,
    label: "6 Months",
    startDate: (todaysDate) => startOfMonth(addMonths(todaysDate, -6)),
    endDate: (todaysDate) => todaysDate
  }
]
// Age of Tickets
export const ageDateFilters = [
  {
    key: 3,
    label: "<1 day",
    startDate: (todaysDate) => todaysDate,
    endDate: () => null
  },
  {
    key: 7,
    label: "1-2 days",
    startDate: (todaysDate) => addDays(todaysDate, -2),
    endDate: (todaysDate) => addDays(todaysDate, -1)
  },
  {
    key: 30,
    label: "3-6 days",
    startDate: (todaysDate) => addDays(todaysDate, -6),
    endDate: (todaysDate) => addDays(todaysDate, -3)
  },
  {
    key: 90,
    label: "7-14 days",
    startDate: (todaysDate) => addDays(todaysDate, -14),
    endDate: (todaysDate) => addDays(todaysDate, -7)
  },
  {
    key: 180,
    label: "> 14 days",
    startDate: () => null,
    endDate: (todaysDate) => addDays(todaysDate, -15)
  }
]
export const databaseTableHeaders = [
  { key: "Resource_ID", text: "Resource Id", showOnCollapsedCard: true },
  { key: "Account", text: "Account Id", showOnCollapsedCard: true },
  { key: "Region", text: "Region", showOnCollapsedCard: true },
  {
    key: "CurrentDatabaseType",
    text: "Current Database Type",
    showOnCollapsedCard: true
  },
  {
    key: "RecommendedAction",
    text: "Recommended Action",
    showOnCollapsedCard: true
  },
  { key: "RecommendedDatabaseType", text: "Recommended Database Type" },
  { key: "RecommendedStorageType", text: "Recommended Storage Type" },
  { key: "RecommendedStorageSize", text: "Recommended Storage Size" },
  { key: "PotentialSavings", text: "Potential Savings" }
]

export const storageTableHeaders = [
  { key: "Resource_ID", text: "Resource Id", showOnCollapsedCard: true },
  { key: "Account", text: "Account Id", showOnCollapsedCard: true },
  { key: "Region", text: "Region", showOnCollapsedCard: true },
  {
    key: "CurrentVolumeType",
    text: "Current Volume Type",
    showOnCollapsedCard: true
  },
  {
    key: "RecommendedVolumeType",
    text: "Recommended Volume Type",
    showOnCollapsedCard: true
  },
  { key: "CurrentVolumeSize", text: "Current Volume Size" },
  { key: "RecommendedVolumeSize", text: "Recommended Volume Size" },
  { key: "CurrentVolumeRate", text: "Current Volume Rate" },
  { key: "RecommendedAction", text: "Recommended Action" },
  { key: "PotentialSavings", text: "Potential Savings" }
]
export const incidentHistoricTrendDateFilters = [
  {
    key: 3,
    label: "3 Months",
    startDate: (todaysDate) => startOfMonth(addMonths(todaysDate, -3)),
    endDate: (todaysDate) => todaysDate
  },
  {
    key: 6,
    label: "6 Months",
    startDate: (todaysDate) => startOfMonth(addMonths(todaysDate, -6)),
    endDate: (todaysDate) => todaysDate
  },
  {
    key: 9,
    label: "9 Months",
    startDate: (todaysDate) => startOfMonth(addMonths(todaysDate, -9)),
    endDate: (todaysDate) => todaysDate
  },
  {
    key: 12,
    label: "12 Months",
    startDate: (todaysDate) => startOfMonth(addMonths(todaysDate, -12)),
    endDate: (todaysDate) => todaysDate
  }
]

export const incidentOpenStates =
  "NEW,ACTIVE,AWAITING_PROBLEM,AWAITING_USER_INFO,AWAITING_EVIDENCE"
export const incidentPriorityMap = [
  {
    key: "P1",
    text: "Priority 1"
  },
  {
    key: "P2",
    text: "Priority 2"
  },
  {
    key: "P3",
    text: "Priority 3"
  },
  {
    key: "P4",
    text: "Priority 4"
  },
  {
    key: "P5",
    text: "Priority 5"
  }
]

export const changeRequestOpenStatesMap = [
  {
    key: "New",
    text: "New"
  },
  {
    key: "Assess",
    text: "Assess"
  },
  {
    key: "Authorize",
    text: "Authorize"
  },
  {
    key: "Scheduled",
    text: "Scheduled"
  },
  {
    key: "Implement",
    text: "Implement"
  },
  {
    key: "Review",
    text: "Review"
  }
]

export const changeRequestResolvedStatesMap = [
  {
    key: "Canceled",
    text: "Canceled"
  },
  {
    key: "Closed",
    text: "Closed"
  }
]
export const openServiceRequestStatesMap = [
  {
    key: "Open",
    text: "Open"
  },
  {
    key: "Pending",
    text: "Pending"
  },
  {
    key: "Work In Progress",
    text: "Work In Progress"
  }
]
export const closedServiceRequestStatesMap = [
  {
    key: "Closed Complete",
    text: "Closed Complete"
  },
  {
    key: "Closed Incomplete",
    text: "Closed Incomplete"
  },
  {
    key: "Closed Skipped",
    text: "Closed Skipped"
  }
]

export const incidentAwaitingStates = [
  "Awaiting Problem",
  "Awaiting User Info",
  "Awaiting Evidence"
]
export const serviceBreakdownCountZero = [
  {
    text: "Cloud Infrastructure Services",
    value: "0"
  },
  {
    text: "Global Cloud Operations Services",
    value: "0"
  },
  {
    text: "Network Services",
    value: "0"
  },
  {
    text: "Security",
    value: "0"
  },
  {
    text: "Miscellaneous",
    value: "0"
  }
]

export const incidentResolvedStates = "RESOLVED,CLOSED"
export const allIncidentStates = `${incidentOpenStates},${incidentResolvedStates}`

export const changeRequestOpenStates =
  "NEW,ASSESS,AUTHORIZE,SCHEDULED,IMPLEMENT,REVIEW"
export const changeRequestResolvedStates = "CLOSED,CANCELED"
export const changeRequestAwaitingStates = "NEW,ASSESS,AUTHORIZE"
export const allChangeRequestStates = `${changeRequestOpenStates},${changeRequestResolvedStates}`

export const serviceRequestOpenStates = "OPEN,PENDING,WORK IN PROGRESS"
export const serviceRequestResolvedStates =
  "CLOSED SKIPPED,CLOSED INCOMPLETE,CLOSED COMPLETE"
export const allServiceRequestStates = `${serviceRequestOpenStates},${serviceRequestResolvedStates}`

export const accessManagementCategories = [
  "USER ACCESS CONTROL",
  "ACTIVE DIRECTORY",
  "SERVICENOW"
]
export const infrastructureRequestCategories = [
  "NETWORK",
  "SERVER",
  "ENVIRONMENT"
]
export const securityCategories = ["SECURITY"]
export const patchingCategories = ["PATCHING"]
export const complianceCategories = ["RISK MANAGEMENT"]

export const availabilitySubCategories = ["CONNECTIVITY ISSUES", "CONNECTIVITY"]
export const performanceSubCategories = ["PERFORMANCE", "OTHER"]

export const itsmDrawerTabs = ["Open", "Resolved", "My Tickets"]
export const slaDrawerTabs = [
  "Response",
  "Resolution",
  "Tickets Solved Response",
  "Tickets Solved Resolution"
]
export const slaDrawerTabsText = [
  "Response Missed",
  "Resolution Missed",
  "Response Achieved",
  "Resolution Achieved"
]

// Overall Analytics

export const priorityMap = {
  "Priority 1": "1 - CRITICAL",
  "Priority 2": "2 - HIGH",
  "Priority 3": "3 - MODERATE",
  "Priority 4": "4 - LOW",
  "Priority 5": "5 - PLANNING"
}

export const priorityDropdownItems = [
  "Priority 1",
  "Priority 2",
  "Priority 3",
  "Priority 4"
]

export const priorityStrings = [
  "1 - Critical",
  "2 - High",
  "3 - Moderate",
  "4 - Low",
  "5 - Planning"
]

// Security
export const statusTypes = [
  "COMPLIANT",
  "NON COMPLIANT",
  "EXEMPTED / EXCEPTED",
  "STOPPED",
  "STOPPED AND EXEMPTED / EXCEPTED",
  "SCAN NEVER PERFORMED"
]
export const resourceState =
  "HOST AGE GREATER THAN 2 DAYS AND SCAN NEVER PERFORMED"
export const statusTags = [
  { key: "Status", value: "COMPLIANT" },
  { key: "Status", value: "NON COMPLIANT" },
  { key: "Status", value: "EXEMPTED" },
  { key: "Status", value: "STOPPED" },
  { key: "Status", value: "STOPPED AND EXEMPTED" },
  { key: "Status", value: "SCAN NEVER PERFORMED" }
]
export const vmStatusTypes = ["COMPLIANT", "NON COMPLIANT", "N/A"]
export const vulnCompilanceHeaders = [
  {
    key: "resource_name",
    text: "Resource Name",
    tooltipRequired: true,
    showOnCollapsedCard: true,
    width: "200px"
  },
  {
    key: "resource_id",
    text: "Resouce ID"
  },
  { key: "environment", text: "Environment" },
  { key: "account_id", text: "Account Id" },
  { key: "status", text: "Compliance" },
  { key: "severity", text: "Severity" },
  { key: "days_vulnerable", text: "Days Vulnerable" },
  { key: "plugin_id", text: "Plugin ID" },
  {
    key: "plugin_name",
    text: "Plugin Name",
    tooltipRequired: true,
    showOnCollapsedCard: true,
    width: "200px"
  },
  {
    key: "plugin_cve",
    text: "Plugin CVE",
    tooltipRequired: true,
    showOnCollapsedCard: true,
    width: "200px"
  },
  {
    key: "vulnerability_sub_type",
    text: "Vulnerability Subtype",
    tooltipRequired: true,
    showOnCollapsedCard: true,
    width: "200px"
  },
  {
    key: "operating_system",
    text: "Operating System",
    tooltipRequired: true,
    tooltipPosition: "left",
    width: "200px"
  },
  {
    key: "resource_state",
    text: "State"
  },
  {
    key: "last_scanned_date",
    text: "Last Scanned Date"
  },
  {
    key: "exemption_ritm",
    text: "Exemption RITM"
  },
  {
    key: "requested_start_date",
    text: "Exempted Start Date"
  },
  {
    key: "requested_end_date",
    text: " Exempted End Date"
  }
]
export const mobileVulnHeaders = [
  {
    key: "resource_name",
    text: "Resource Name",
    tooltipRequired: true,
    showOnCollapsedCard: true,
    width: "200px"
  },
  {
    key: "resource_state",
    text: "Compliance Status",
    showOnCollapsedCard: true
  },
  {
    key: "reason",
    text: "Reason",
    showOnCollapsedCard: true
  },
  {
    key: "last_scan_time",
    text: "Last Scanned Date",
    showOnCollapsedCard: true
  }
]
export const mobileVulnStatus = (status, forClassName = false) => {
  if (status === "COMPLIANT") return "Compliant"
  if (status === "NON COMPLIANT") return "Non-Compliant"
  if (status === "EXEMPTED") return "Exempted"
  if (status === "EXEMPTED / EXCEPTED") return "Exempted / Excepted"
  if (status === "EXCEPTED") return forClassName ? "Exempted" : "Excepted"
  if (status === "STOPPED") return "Stopped"
  if (status === "SCAN NEVER PERFORMED")
    return forClassName ? "Scan-never-performed" : "Scan Never Performed"
  if (status === "STOPPED AND EXEMPTED")
    return forClassName ? "Stopped-Exempted" : "Stopped & Exempted"
  if (status === "STOPPED AND EXEMPTED / EXCEPTED")
    return "Stopped & Exempted / Excepted"
  if (status === "STOPPED AND EXCEPTED") {
    return forClassName ? "Stopped-Exempted" : "Stopped & Excepted"
  }
  return status
}

// Fixed Vulnerabilities
export const patchedHeaders = [
  { key: "account_id", text: "Account ID", showOnCollapsedCard: true },
  { key: "project_name", text: "Project Name", showOnCollapsedCard: true },
  { key: "resource_id", text: "Resource ID", showOnCollapsedCard: true },
  {
    key: "resource_name",
    text: "Resource Name",
    tooltipRequired: true,
    showOnCollapsedCard: true,
    width: "200px"
  },
  { key: "resource_state", text: "Resource State" },
  { key: "environment", text: "Environment" },
  { key: "hosting_vendor", text: "Hosting Vendor" },
  { key: "plugin_id", text: "Plugin ID" },
  {
    key: "plugin_name",
    text: "Plugin Name",
    tooltipRequired: true,
    width: "200px"
  },
  {
    key: "plugin_family",
    text: "Plugin Family",
    tooltipRequired: true,
    width: "200px"
  },
  {
    key: "severity",
    text: "Severity"
  },
  {
    key: "vulnerability_type",
    text: "Vulnerability Type"
  },
  {
    key: "vulnerability_sub_type",
    text: "Vulnerability Subtype",
    tooltipRequired: true,
    width: "200px"
  },

  { key: "days_vulnerable", text: "Vulnerability Age" },

  { key: "status", text: "State" },
  {
    key: "plugin_cve",
    text: "Plugin CVE",
    tooltipRequired: true,
    width: "200px"
  },
  {
    key: "reference_url",
    text: "Reference URL",
    tooltipRequired: true,
    width: "200px"
  },
  {
    key: "patching_status",
    text: "Patching Status"
  }
]
export const patchedMapSeverity = (status) => {
  if (status === "CRITICAL") return "Critical"
  if (status === "MEDIUM") return "Medium"
  if (status === "HIGH") return "High"
  if (status === "LOW") return "Low"
  return status
}

export const patchedMapStatus = (status, forClassName = false) => {
  if (status === "COMP") return "Compliant"
  if (status === "NONCOMP") return "Non-Compliant"
  if (status === "EXEMP") return "Exempted"
  if (status === "STOPPED") return "Stopped"
  if (status === "STOPPED AND EXEMPTED")
    return forClassName ? "Stopped-Exempted" : "Stopped & Exempted"
  return status
}
export const patchedStatusTags = [
  { key: "severity", value: "LOW" },
  { key: "severity", value: "MEDIUM" },
  { key: "severity", value: "HIGH" },
  { key: "severity", value: "CRITICAL" }
]

export const portalThemes = [
  { key: "theme-deloitte", text: "Default" },
  { key: "theme-protanopia", text: "Protanopia" },
  { key: "theme-deuteranopia", text: "Deuteranopia" },
  { key: "theme-tritanopia", text: "Tritanopia" },
  { key: "theme-achromatopsia", text: "Achromatopsia" }
]

export const ET_TIMEZONE = "America/New_York"

export const severityTypes = ["LOW", "MEDIUM", "HIGH", "CRITICAL"]

export const prodSnowHost = "https://deloittecloud.service-now.com"

export const getRequestRedirectionLink = (userRole, snowHost) => {
  if (isExternalUser(userRole))
    return `${snowHost}/sc_req_item.do?sysparm_view=ess&sysparm_view=ess&sysparm_domain=null&sysparm_domain_scope=null&sysparm_nostack=yes&sys_id=`
  return `${snowHost}/nav_to.do?uri=/sc_req_item.do?sys_id=`
}

export const getRedirectionLinkCR = (userRole, snowHost) => {
  if (isExternalUser(userRole))
    return `${snowHost}/change_request.do?sysparm_view=ess&sysparm_view=ess&sysparm_domain=null&sysparm_domain_scope=null&sysparm_nostack=yes&sys_id=`
  return snowHost + "/change_request.do?sys_id="
}

export const datadogHostHeaders = [
  {
    key: "pod",
    text: "Pod Name"
  },
  {
    key: "project_name",
    text: "Project Name"
  },
  {
    key: "account_id",
    text: "Account Id",
    tooltipRequired: true,
    width: "200px"
  },
  {
    key: "resource_id",
    text: "Resource Name",
    tooltipRequired: true,
    width: "200px"
  },
  {
    key: "compliance",
    text: "Compliance"
  },
  {
    key: "reasons",
    text: "Reason for Non-Compliance",
    tooltipRequired: true,
    width: "250px"
  },
  {
    key: "agent_version",
    text: "Agent Version"
  },
  {
    key: "agent_status",
    text: "Agent Status"
  },
  {
    key: "datadog_org",
    text: "Datadog Org"
  }

  // {
  //   key: "agent_version",
  //   text: "Agent Version"
  // },
  // {
  //   key: "client_name",
  //   text: "Client Name"
  // },
  // {
  //   key: "cloud_type",
  //   text: "Cloud Type"
  // },
]
export const podVmInventoryHeaders = [
  {
    key: "pod",
    text: "Pod Name"
  },
  {
    key: "project_name",
    text: "Project Name"
  },
  {
    key: "resource_id",
    text: "VM Id",
    tooltipRequired: true,
    width: "200px"
  },
  {
    key: "resource_name",
    text: "Resource Name"
  },
  {
    key: "operating_system",
    text: "Operating System",
    tooltipRequired: true,
    width: "200px"
  },
  {
    key: "environment",
    text: "Environment"
  },
  {
    key: "account_id",
    text: "Account Id",
    tooltipRequired: true,
    width: "200px"
  },
  {
    key: "account_vendor",
    text: "Cloud Provider"
  },
  {
    key: "resource_state",
    text: "Resource State"
  }
]
export const vendorUrls = {
  "Amazon Web Services": [
    "https://status.aws.amazon.com/rss/ec2-us-east-1.rss",
    "https://status.aws.amazon.com/rss/ec2-us-east-2.rss",
    "https://status.aws.amazon.com/rss/ec2-us-west-1.rss",
    "https://status.aws.amazon.com/rss/ec2-us-west-2.rss",
    "https://status.aws.amazon.com/rss/s3-us-standard.rss",
    "https://status.aws.amazon.com/rss/s3-us-east-2.rss",
    "https://status.aws.amazon.com/rss/s3-us-west-1.rss",
    "https://status.aws.amazon.com/rss/s3-us-west-2.rss",
    "https://status.aws.amazon.com/rss/ec2-ca-central-1.rss",
    "https://status.aws.amazon.com/rss/s3-ca-central-1.rss",
    "https://status.aws.amazon.com/rss/ec2-ap-south-1.rss",
    "https://status.aws.amazon.com/rss/ec2-ap-southeast-1.rss",
    "https://status.aws.amazon.com/rss/ec2-ap-southeast-2.rss",
    "https://status.aws.amazon.com/rss/ec2-ap-east-1.rss",
    "https://status.aws.amazon.com/rss/ec2-ap-northeast-1.rss",
    "https://status.aws.amazon.com/rss/ec2-ap-northeast-2.rss",
    "https://status.aws.amazon.com/rss/ec2-ap-northeast-3.rss",
    "https://status.aws.amazon.com/rss/s3-ap-south-1.rss",
    "https://status.aws.amazon.com/rss/s3-ap-southeast-1.rss",
    "https://status.aws.amazon.com/rss/s3-ap-southeast-2.rss",
    "https://status.aws.amazon.com/rss/s3-ap-east-1.rss",
    "https://status.aws.amazon.com/rss/s3-ap-northeast-1.rss",
    "https://status.aws.amazon.com/rss/s3-ap-northeast-3.rss",
    "https://status.aws.amazon.com/rss/s3-ap-northeast-2.rss"
  ],
  "Microsoft Azure": ["https://azurestatuscdn.azureedge.net/en-us/status/feed"],
  "Google Cloud Platform": ["https://status.cloud.google.com/en/feed.atom"],
  "Oracle Cloud": [
    "https://ocistatus.oraclecloud.com/api/v2/incident-summary.rss"
  ]
}

export const datadogStatusTypes = ["Compliant", "Non-Compliant", "Exempted"]

export const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
]

export const isPlural = (count) => (count > 1 ? "s" : "")

export const modularityArray = {
  itsm_page: false,
  itsm_sla: false,
  secComp_page: false,
  secComp_vulnerabilities: false,
  secComp_fixedVulnerabilities: false,
  secComp_antiMalware: false,
  prismaCloud_page: false,
  infraMonitoring_page: false,
  vmInventory_page: false,
  uar_page: false,
  cloudFinancial_page: false,
  cloudFinancial_optimization: false,
  couldFinancial_spend: false,
  cmsReports_page: false,
  quickLinks_page: false,
  keyContacts_page: false,
  cloudAlerts_page: false,
  keyRotation_page: false,
  monitoringCompliance_page: false,
  cms_users_pages: false
}

export const AntimalwareAgentStates = {
  NON_COMPLIANT: "NON_COMPLIANT",
  COMPLIANT: "COMPLIANT",
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  EXCEPTED: "EXCEPTED",
  EXEMPTED: "EXEMPTED",
  RUNNING: "RUNNING",
  STOPPED: "STOPPED"
}

export const cloudPolicyHeaders = [
  { key: "policy_name", text: "Name", tooltipRequired: true, width: "200px" },
  {
    key: "policy_description",
    text: "Description",
    tooltipRequired: true,
    width: "200px"
  },
  { key: "compliance_requirement", text: "Compliance Requirement" },
  { key: "policy_severity", text: "Policy Severity" }
]

export const cloudAlertHeaders = [
  {
    key: "resource_name",
    text: "Resource Name",
    tooltipRequired: true,
    width: "200px"
  },
  {
    key: "resource_id",
    text: "Resource ID",
    tooltipRequired: true,
    width: "200px"
  },
  { key: "account_id", text: "Account ID" },
  {
    key: "alert_status",
    text: "Alert Status"
  },
  {
    key: "alert_reason",
    text: "Alert Reason"
  },
  {
    key: "alert_time",
    text: "Alert Time"
  },
  {
    key: "alert_firstseen",
    text: "Alert Firstseen"
  },
  {
    key: "alert_lastseen",
    text: "Alert Lastseen"
  },

  { key: "compliance_requirement", text: "Compliance Requirement" },
  {
    key: "compliance_standard",
    text: "Compliance Standard"
  },
  {
    key: "hosting_vendor",
    text: "Hosting Vendor"
  },
  {
    key: "policy_labels",
    text: "Policy Labels"
  },
  {
    key: "policy_name",
    text: "Policy Name",
    tooltipRequired: true,
    width: "200px"
  },
  {
    key: "policy_severity",
    text: "Policy Severity"
  },
  {
    key: "policy_system_default",
    text: "Policy System Default"
  },
  { key: "resource_type", text: "Resource Type" },

  { key: "resource_cloud_type", text: "Resource Cloud Type" }
]

export const fixedVulnerabilitiesHeaders = [
  {
    key: "resource_name",
    text: "Resource Name",
    tooltipRequired: true,
    width: "200px"
  },
  { key: "resource_id", text: "Resource Id" },
  { key: "environment", text: "Environment" },
  { key: "account_id", text: "Account Id" },
  {
    key: "severity",
    text: "Severity"
  },
  {
    key: "days_vulnerable",
    text: "Days Vulnerable"
  },

  {
    key: "plugin_id",
    text: "Plugin Id"
  },
  {
    key: "plugin_name",
    text: "Plugin Name",
    tooltipRequired: true,
    width: "200px"
  },
  {
    key: "plugin_cve",
    text: "Plugin CVE",
    tooltipRequired: true,
    width: "200px"
  },
  {
    key: "vulnerability_sub_type",
    text: "Vulnerability Sub Type",
    tooltipRequired: true,
    width: "200px"
  },

  {
    key: "operating_system",
    text: "Operating System",
    tooltipRequired: true,
    tooltipPosition: "left",
    width: "200px"
  },
  {
    key: "last_fixed",
    text: "Last Fixed Date"
  }
]
export const zeroDayVulnerabilitieHeaders = [
  {
    key: "resource_name",
    text: "Resource Name",
    width: "120px",
    tooltipRequired: true
  },
  {
    key: "resource_id",
    text: "Resource ID",
    width: "120px",
    tooltipRequired: true
  },
  {
    key: "environment",
    text: "Environment"
  },
  {
    key: "zerodaycomp",
    text: "Compliance Status"
  },
  {
    key: "snow_ritm",
    text: "Zero Day RITM"
  },
  {
    key: "snow_planned_date",
    text: "Planned Date"
  },
  {
    key: "snow_due_date",
    text: "Due Date"
  },

  {
    key: "exemption_ritm_number",
    text: "Exception RITM"
  },
  {
    key: "exemption_request_end_date",
    text: "Exception End Date"
  },
  {
    key: "snow_patching_cr",
    text: "Patching Change Request"
  },
  {
    key: "app",
    text: "App"
  },
  {
    key: "expiring_exception_before_due",
    text: "Expiring Before Due Date",
    hideHeader: true
  }
]
export const podZeroDayVulnerabilitieHeaders = [
  {
    key: "pod",
    text: "POD Name",
    width: "150px",
    tooltipRequired: true
  },
  {
    key: "project_name",
    text: "Project Name",
    width: "150px",
    tooltipRequired: true
  },
  {
    key: "environment",
    text: "Environment",
    width: "120px"
  },
  {
    key: "compliance_status",
    text: "Compliance Status",
    tooltipContent:
      "The compliance status shown is specific to the environment. To get the compliance status specific to the resources, check the non-compliant count column."
  },
  {
    key: "non_compliance_count",
    text: "Non-Compliance Count",
    contentPosition: "justify-content-center"
  },
  {
    key: "patched_date",
    text: "Patched Planned Date"
  },
  {
    key: "excemption_RITM",
    text: "Exception RITM"
  }
]
export const ritmNotificationHeaders = [
  { key: "ritm_number", text: "RITM Number" },
  { key: "request_number", text: "Request Number" },
  {
    key: "short_description",
    text: "Short Description",
    tooltipRequired: true,
    width: "200px"
  },
  { key: "opened_at", text: "Opened At" },
  { key: "priority", text: "Priority" },
  { key: "approval", text: "Approval" }
]

export const crNotificationHeaders = [
  { key: "change_number", text: "Change Number" },
  { key: "project_name", text: "Project Name" },
  {
    key: "short_description",
    text: "Short Description",
    tooltipRequired: true,
    width: "200px"
  },
  { key: "chg_opened_by", text: "Created By" },
  { key: "chg_start_date", text: "Expected Start" },
  { key: "chg_end_date", text: "Due Date" },
  { key: "change_state", text: "Status" },
  { key: "notes", text: "Note", tooltipRequired: true, width: "200px" }
]
export const dateRangeFiltersForWithThreeMonths = [
  {
    key: "Last 7 days",
    text: "Last 7 days"
  },
  {
    key: "Last 14 days",
    text: "Last 14 days"
  },
  {
    key: "Last 30 days",
    text: "Last 30 days"
  }
]

export const dateRangeFiltersAfterThreeMonths = [
  {
    key: "Last 30 days",
    text: "Last 30 days"
  },
  {
    key: "Last 60 days",
    text: "Last 60 days"
  },
  {
    key: "Last 90 days",
    text: "Last 90 days"
  },
  {
    key: "Last 180 days",
    text: "Last 180 days"
  }
]

export const podHealthAssessmentHeaders = [
  {
    key: "pod",
    text: "Pod",
    tooltipRequired: true,
    showOnCollapsedCard: true,
    width: "200px"
  },
  {
    key: "project_name",
    text: "Project Name",
    tooltipRequired: true,
    showOnCollapsedCard: true,
    width: "200px"
  },
  {
    key: "project",
    text: "Project ID",
    tooltipRequired: true,
    showOnCollapsedCard: true,
    width: "200px"
  },
  {
    key: "cloud_policy_onboarding",
    text: "Cloud Policy Onboarding",
    contentPosition: "justify-content-center"
  },
  {
    key: "anti-malware",
    text: "Anti-Malware",
    contentPosition: "justify-content-center"
  },
  {
    key: "vulnerability_management",
    text: "Vulnerability Management",
    contentPosition: "justify-content-center"
  },
  {
    key: "cis_image_hardening",
    text: "CIS Image Hardening",
    contentPosition: "justify-content-center"
  },
  {
    key: "servicenow_integration",
    text: "ServiceNow Integration",
    contentPosition: "justify-content-center"
  },
  {
    key: "okta_asa_onboarding",
    text: "Okta ASA Onboarding",
    contentPosition: "justify-content-center"
  },
  {
    key: "opencloud_platform_logs",
    text: "OpenCloud Platform Logs",
    contentPosition: "justify-content-center"
  },
  {
    key: "splunk_platform_logs",
    text: "Splunk Platform Logs",
    contentPosition: "justify-content-center"
  },
  {
    key: "os_logs",
    text: "OS Logs",
    contentPosition: "justify-content-center"
  },
  {
    key: "encryption_logging",
    text: "Encryption Logging",
    contentPosition: "justify-content-center"
  },

  {
    key: "backup_compliance",
    text: "Backup Compliance",
    contentPosition: "justify-content-center"
  }
]
